export default __webpack_public_path__ + "static/media/Ballroll_00376.ab8508b3.png";